import { ModuleFE_EHRFlowsheetConfiguration } from './ModuleFE_EHRFlowsheetConfiguration.js';
export const ModulePackFE_EHRFlowsheetConfiguration = [ModuleFE_EHRFlowsheetConfiguration];
//# sourceMappingURL=module-pack.js.map